import React from "react";
import "./App.scss";
import { BG_SVG } from "./assets/svg-components/logo";
import { SIBI_SVG } from "./assets/svg-components/sibi-logo";

const App: React.FC = () => {
  const handleButtonClick = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="page_container">
      <div className="image_container">
        {BG_SVG}
      </div>

      <div className="content_container">
        <div className="brand">
          {SIBI_SVG}
          <span>SiBI</span>
        </div>

        <div className="headline">
          SIBI AI is a production-grade agentic backend engineered to interpret and respond to enterprise data–specific queries with high precision. It seamlessly integrates structured enterprise datasets with unstructured policy and knowledge artifacts to deliver accurate, explainable, and compliance-aware insights—continuously and in real time.
        </div>

        <div className="actions">
          <div className="pill" onClick={() => handleButtonClick('https://finance-ai.simplogics.com/')}>Finance</div>
          <div className="pill" onClick={() => handleButtonClick('https://sales-ai.simplogics.com/')}>Sales / Marketing</div>
          <div className="pill" onClick={() => handleButtonClick('https://automobile-ai.simplogics.com/')}>Automobile</div>
        </div>
      </div>
    </div>
  );
};

export default App;
